import { render } from "./eatXfbmReplaceRatio.vue?vue&type=template&id=31978081"
import script from "./eatXfbmReplaceRatio.vue?vue&type=script&lang=js"
export * from "./eatXfbmReplaceRatio.vue?vue&type=script&lang=js"

import "./eatXfbmReplaceRatio.vue?vue&type=style&index=0&id=31978081&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__